require("./qf/restricted-shipping");
require("./qf/global_listeners");
require("./snippets/v3-accordion");
require("./qf/wishlistAsObject");
require("./qf/cart");
require("./qf/loadMore");
require("./qf/ModalController");
require("./snippets/predictive-search");
require("./snippets/v3-accordion");

window.modalController = new ModalController()
window.wishlist = new WishlistObjectQf();
window.globalListeners = new GlobalListeners();
window.cart = new CartQf();
window.restrictedShipping = new RestrictedShipping();